module.exports = __webpack_public_path__ + "static/img/logo@2x.3a28b1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ym/logo@2x.png
// module id = EE6p
// module chunks = 1